// Medical History Templates
// Basic templates for medical history forms

const Templates = {
  // Basic template structure - you can expand this based on your needs
  allergies: {
    field: 'allergies',
    label: 'Allergies',
    type: 'array',
    items: []
  },
  chronicIllnesses: {
    field: 'chronicIllnesses',
    label: 'Chronic Illnesses',
    type: 'array',
    items: []
  },
  medications: {
    field: 'meds',
    label: 'Medications',
    type: 'array',
    items: []
  },
  familyHistory: {
    field: 'familyHistory',
    label: 'Family History',
    type: 'object',
    fields: {}
  },
  lifestyle: {
    field: 'lifestyle',
    label: 'Lifestyle',
    type: 'object',
    fields: {}
  },
  mentalHealth: {
    field: 'mentalHealth',
    label: 'Mental Health',
    type: 'object',
    fields: {}
  },
  surgicalHistory: {
    field: 'surgicalHistory',
    label: 'Surgical History',
    type: 'array',
    items: []
  },
  covidInfo: {
    field: 'covidInfo',
    label: 'COVID Information',
    type: 'object',
    fields: {}
  }
}

export default Templates
